import { render } from "./FormDropdown.vue?vue&type=template&id=00f735f6"
import script from "./FormDropdown.vue?vue&type=script&lang=js"
export * from "./FormDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__